import { createPortal } from "react-dom";
import { Download, Loader2, X } from "lucide-react";

type Props = {
  open: boolean;
  imageUrl: string | null;
  filename: string | null;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onDownload: () => void;
};

export function JustificationImagePreview({
  open,
  imageUrl,
  filename,
  loading,
  error,
  onClose,
  onDownload,
}: Props) {
  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-950/65 p-4 backdrop-blur-sm">
      <div className="flex max-h-[92vh] w-full max-w-5xl flex-col overflow-hidden rounded-[30px] border border-white/20 bg-white shadow-[0_30px_100px_rgba(15,23,42,.35)]">
        <div className="flex items-center justify-between gap-4 border-b border-slate-100 px-5 py-4">
          <div className="min-w-0">
            <div className="text-sm font-black text-slate-950">Vista preliminar</div>
            <div className="mt-1 truncate text-xs font-semibold text-slate-500">
              {filename ?? "Imagen adjunta"}
            </div>
          </div>
          <div className="flex items-center gap-2">
            {imageUrl && (
              <button
                type="button"
                onClick={onDownload}
                className="inline-flex items-center gap-2 rounded-xl border border-cyan-100 bg-cyan-50 px-3 py-2 text-xs font-black text-cyan-700 transition hover:bg-cyan-100"
              >
                <Download size={14} />
                Descargar
              </button>
            )}
            <button
              type="button"
              onClick={onClose}
              className="grid h-9 w-9 place-items-center rounded-xl border border-slate-200 bg-white text-slate-500 transition hover:bg-slate-50 hover:text-slate-900"
              aria-label="Cerrar vista preliminar"
            >
              <X size={17} />
            </button>
          </div>
        </div>

        <div className="min-h-0 flex-1 overflow-auto bg-slate-100 p-5">
          {loading ? (
            <div className="flex min-h-[420px] items-center justify-center gap-3 text-sm font-black text-slate-500">
              <Loader2 size={20} className="animate-spin" />
              Cargando imagen...
            </div>
          ) : error ? (
            <div className="flex min-h-[320px] items-center justify-center rounded-2xl border border-rose-100 bg-rose-50 px-6 text-center text-sm font-bold text-rose-700">
              {error}
            </div>
          ) : imageUrl ? (
            <div className="flex min-h-[420px] items-center justify-center">
              <img
                src={imageUrl}
                alt={filename ?? "Justificación adjunta"}
                className="max-h-[74vh] max-w-full rounded-2xl object-contain shadow-[0_16px_50px_rgba(15,23,42,.16)]"
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>,
    document.body,
  );
}
